import { createMockBridge } from './mock.js';
import { AirportWindScene } from './scene.js';
import { WindStationTransport } from './transport.js';
import { WindStationUI } from './ui.js';

// Browser entry point: every accepted firmware report is rendered by both the
// DOM interface and the Three.js scene. ?mock=1 swaps only the iframe bridge,
// allowing the production renderer and UI to run without laboratory hardware.
const mockEnabled = new URLSearchParams(window.location.search).get('mock') === '1';
let transport;
let mockBridge;
let scene;
let reducedMotion = false;

const ui = new WindStationUI({
  onScenario: (name) => transport.requestScenario(name),
  onRestart: () => transport.requestRestart(),
  onReducedMotion: (reduced) => {
    reducedMotion = reduced;
    scene?.setReducedMotion(reduced);
  },
});

// Keep the controls and textual reports usable if WebGL is unavailable. Create
// the UI first so synchronous renderer failures can be explained on the page.
try {
  scene = new AirportWindScene(document.querySelector('#scene-host'), {
    onReady: (error) => ui.setSceneReady(error),
    debug: new URLSearchParams(window.location.search).get('debug') === '1',
  });
  scene.setReducedMotion(reducedMotion);
  scene.start();
} catch (error) {
  console.error('[airport-wind] 3D renderer unavailable', error);
  ui.setSceneReady('3D rendering is unavailable in this browser. You can still use the controls and read the station status.');
}

if (mockEnabled) {
  mockBridge = createMockBridge((raw) => transport.receiveReport(raw));
}

transport = new WindStationTransport({
  onState: (state) => {
    ui.render(state);
    scene?.applyState(state);
  },
  onConnection: (status) => ui.setConnection(status),
  onPending: (pending) => ui.setPending(pending),
  send: mockEnabled ? (raw) => mockBridge.send(raw) : undefined,
  notifyLoaded: mockEnabled ? () => {} : undefined,
});

transport.start();

window.addEventListener('beforeunload', () => {
  transport.stop();
  mockBridge?.destroy();
  scene?.dispose();
});
